import { formatPrice } from '@/context/CartContext'

type ProductCardPriceProps = {
  hasPrice: boolean
  finalPrice: number
  hasDiscount: boolean
  discountPercent?: number | null
  originalPrice?: number | null
  priceClassName: string
  emptyClassName: string
}

export default function ProductCardPrice({
  hasPrice,
  finalPrice,
  hasDiscount,
  discountPercent,
  originalPrice,
  priceClassName,
  emptyClassName,
}: ProductCardPriceProps) {
  if (!hasPrice) {
    return <p className={emptyClassName}>Нет цены</p>
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      <p className={priceClassName}>{formatPrice(finalPrice)}</p>
      {hasDiscount && discountPercent != null && discountPercent > 0 && (
        <span className="inline-flex items-center rounded-md bg-red-100 px-2 py-0.5 text-xs font-semibold text-red-600">
          -{Math.round(discountPercent)}%
        </span>
      )}
      {hasDiscount && originalPrice != null && (
        <p className="text-sm text-gray-400 line-through">{formatPrice(originalPrice)}</p>
      )}
    </div>
  )
}
